<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-import-solution
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="$emit('reloadSolutions')"
            >
              <template v-slot:title>
                Importar
                {{ this.isAT ? "Iniciativas" : isGov ? "Fases" : "Soluções" }}
              </template>
            </app-modal-import-solution>

            <app-modal-insert-solution
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="load"
              :allSolutions="solutions"
              :municipioSolucao="municipioSolucaoPT"
              :filter="filter"
              v-if="
                isFullAdmin ||
                filter.municipioGrupoSolucao.municipioGrupoSolucaoId
              "
            >
              <template v-slot:title>
                Cadastrar
                {{ this.isAT ? "Iniciativas" : isGov ? "Fases" : "Soluções" }}
              </template>
            </app-modal-insert-solution>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="solutions"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item="props">
            <tr
              :class="{
                evidenciada: props.item.concluida,
                evidenciar: props.item.interrompida,
              }"
            >
              <td>{{ props.item.nome }}</td>
              <td>{{ props.item.descricao }}</td>
              <td v-if="props.item.municipioGrupoSolucao">
                {{ props.item.municipioGrupoSolucao.nome }}
              </td>
              <td>
                <span v-if="props.item.usuario">
                  {{ props.item.usuario.nome }}
                </span>
              </td>

              <td>
                <v-textarea
                  v-model="props.item.justificativa"
                  :readonly="props.item.concluida || props.item.interrompida"
                ></v-textarea>
              </td>

              <td>
                <app-modal-insert-solution
                  :object="props.item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter.municipioGrupoSolucao"
                  @onSave="$emit('reloadSolutions')"
                >
                  <template v-slot:title> Edição de Solução </template>
                </app-modal-insert-solution>
              </td>
              <td>
                <app-modal-delete-solution
                  :payload="props.item"
                  v-if="!props.item.concluida && !props.item.interrompida"
                  @onSave="$emit('reloadSolutions')"
                ></app-modal-delete-solution>
              </td>
              <td>
                <app-modal-confirm-stop-solution
                  :solution="props.item"
                  v-if="!props.item.concluida && !props.item.interrompida"
                  @onCloseModal="$emit('reloadSolutions')"
                >
                  <template v-slot:title> Interromper Solução </template>
                </app-modal-confirm-stop-solution>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AppRetrieveSolution
          :solutions="disabledSolutions"
          @onRecover="$emit('reloadSolutions')"
        ></AppRetrieveSolution>
      </v-col>
    </v-row>

    <app-modal-confirm-finish-solution
      :dialog="modalConfirmFinishSolution"
      :solutions="solutionsToFinish"
      @onCloseModal="closeModalFinish()"
    >
    </app-modal-confirm-finish-solution>
  </v-container>
</template>

<script>
import AppModalInsertSolution from "./ModalInsert";
import AppModalConfirmStopSolution from "./ModalConfirmStopSolution";
import AppModalDeleteSolution from "./ModalDelete";
import AppModalConfirmFinishSolution from "@/modules/solution/components/city/ModalConfirmFinishSolution";
import AppModalImportSolution from "@/modules/solution/components/city/ModalImport";
import AppRetrieveSolution from "./RetrieveSolution";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppSolutionList",
  props: {
    filter: { type: Object, required: true },
    municipioSolucao: { type: Object, required: false },
    solutions: { type: Array, required: true },
    disabledSolutions: { type: Array, required: true },
  },
  components: {
    AppModalInsertSolution,
    AppModalDeleteSolution,
    AppModalConfirmStopSolution,
    AppModalConfirmFinishSolution,
    AppModalImportSolution,
    AppRetrieveSolution,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupo de Solução",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "Consultor",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
        { text: "Interromper", value: "acoes_interromper", sortable: false },
      ],
      headers_ma: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupo de Solução",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "Responsável",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      modalConfirmFinishSolution: false,
      solutionsToFinish: [],
      municipioSolucaoPT: {
        municipioSolucao: {},
      },
    };
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isNA",
      "isFullAdmin",
      "uf",
      "isAT",
      "isGov",
    ]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.$emit("reloadSolutions");
    },
    finishSolution(solution) {
      this.solutionsToFinish = [];
      this.solutionsToFinish.push(solution);
      this.modalConfirmFinishSolution = true;
    },
    closeModalFinish() {
      this.modalConfirmFinishSolution = false;
      this.$emit("reloadSolutions");
    },
  },
  mounted() {
    if (this.uf === "MA") {
      this.headers = this.headers_ma;
    }

    if (this.isAT) {
      this.headers = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupos de Iniciativas",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "ATS",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
        { text: "Interromper", value: "acoes_interromper", sortable: false },
      ];
      this.headers_ma = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupos de Iniciativas",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "Responsável",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ];
    }
  },
  watch: {
    "municipioSolucao.municipioSolucao"(newValue) {
      if (newValue) {
        this.municipioSolucaoPT.municipioSolucao = newValue;
      }
    },
    object(newValue) {
      this.payload = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./../style.scss";
</style>
